module.exports = __webpack_public_path__ + "static/media/icon_cart.97601c3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_cart.svg
// module id = 773
// module chunks = 0